import { getActions } from "../actions/getPieChartData";

const defaultState = {
  data: [],
  loading: false,
  error: {},
};

const getResourceReducer = (resource) => (state = defaultState, action) => {
  switch (action.type) {
    case getActions(resource).start:
      return {
        data: {},
        error: {},
        loading: true,
      };
    case getActions(resource).success:
      return {
        data: action.data,
        error: {},
        loading: false,
      };
    case getActions(resource).error:
      return {
        data: {},
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};

const reducers = {
  portalData: getResourceReducer("portal"),
  sectorsData: getResourceReducer("sectors"),
  sdgData: getResourceReducer("sgd"),
  homePortalsPieChartData: getResourceReducer("homePortals"),
  homeSdgsPieChartData: getResourceReducer("homeSdgs"),
  homeSectorsPieChartData: getResourceReducer("homeSectors"),
};

export default reducers;



// WEBPACK FOOTER //
// ./shared/reducers/pieChartData.js